import format from 'date-fns/format'

export const formatTimestamp = (dt: string) => {
  return format(dt, 'HH:mma, D MMM')
}

export default formatTimestamp
